<template>
  <button
    :class="[
      'mui-button',
      'clickable',
      'flex',
      { primary: type === 'primary' },
      { yellow: type === 'yellow' },
      { green: type === 'green' },
      { grey: type === 'grey' },
      { large: size === 'large' },
      { disabled: disabled },
    ]"
    @click="handleClick"
  >
    <span v-show="loading">
      <i class="el-icon-loading"></i>
      {{ loadingText }}
    </span>
    <span v-show="!loading">
      <svg-icon :type="icon" class="icon-16 m-r-16" v-if="!!icon" />
      <slot></slot>
      <svg-icon :type="iconAfter" class="icon-16 m-l-16" v-if="!!iconAfter"
    /></span>
  </button>
</template>

<script>
export default {
  name: "MuiButton",
  props: {
    // 类型
    type: {
      type: String,
      default: "link",
      validator: function (value) {
        return ["primary", "yellow", "green", "grey", "link"].includes(value);
      },
    },
    // 图标（文字前）
    icon: {
      type: String,
      default: "",
    },
    // 图标（文字后）
    iconAfter: {
      type: String,
      default: "",
    },
    // 大小
    size: {
      type: String,
      default: "normal",
      validator: function (value) {
        return ["normal", "large"].includes(value);
      },
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否加载中
    loading: {
      type: Boolean,
      default: false,
    },
    // 加载中文案
    loadingText: {
      type: String,
      default: "Loading...",
    },
  },
  methods: {
    handleClick(event) {
      !this.disabled && !this.loading && this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.mui-button {
  outline: none;
  border: none;
  background: none;
  padding: 6px 8px;
  border-radius: 4px;
  color: $grey;
  transition: all 0.15s linear;
  justify-content: center;

  &:hover {
    color: darken($grey, 20%);
  }

  &.primary {
    background-color: $primary;
    color: #ffffff;

    &:hover {
      background-color: darken($primary, 20%);
    }
  }
  &.yellow {
    background-color: $yellow;
    color: #ffffff;

    &:hover {
      background-color: darken($yellow, 10%);
    }
  }
  &.green {
    background-color: $success;
    color: #ffffff;

    &:hover {
      background-color: darken($success, 10%);
    }
  }
  &.grey {
    background-color: $grey-4;
    color: $grey-2;

    &:hover {
      background-color: darken($grey-4, 10%);
    }
  }

  &.large {
    padding: 12px 16px;
    font-size: 16px;
    border-radius: 8px;
    font-weight: bold;
  }

  &.disabled {
    cursor: not-allowed;
    background-color: $grey-4;
    color: $grey-2;

    &:hover {
      background-color: $grey-4;
    }
  }
}
</style>
